import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'danger' | 'dangerOutline' | 'ghost' | 'success';
  size?: 'sm' | 'md' | 'lg';
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...props
}) => {
  let base = 'rounded-md font-medium focus:outline-none transition-colors';
  let color = '';
  let padding = '';

  switch (variant) {
    case 'secondary':
      color =
        'bg-gray-200 text-gray-700 hover:bg-gray-300 disabled:cursor-not-allowed disabled:opacity-60';
      break;
    case 'outline':
      color =
        'border border-gray-300 bg-transparent text-gray-700 hover:bg-gray-50 hover:border-gray-400 disabled:cursor-not-allowed disabled:opacity-50';
      break;
    case 'danger':
      color =
        'bg-red-600 text-white hover:bg-red-700 disabled:bg-red-400 disabled:cursor-not-allowed disabled:opacity-60';
      break;
    case 'dangerOutline':
      color =
        'border border-red-200 text-red-700 bg-red-50 hover:bg-red-100 disabled:cursor-not-allowed disabled:opacity-50';
      break;
    case 'ghost':
      color =
        'bg-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50';
      break;
    case 'success':
      color =
        'bg-green-600 text-white hover:bg-green-700 disabled:bg-green-400 disabled:cursor-not-allowed disabled:opacity-60';
      break;
    default:
      color =
        'bg-blue-600 text-white shadow-sm hover:bg-blue-700 hover:shadow-md disabled:bg-blue-400 disabled:cursor-not-allowed disabled:opacity-60 disabled:shadow-none';
  }

  switch (size) {
    case 'sm':
      padding = 'py-1 px-3 text-sm';
      break;
    case 'lg':
      padding = 'py-3 px-6 text-lg';
      break;
    default:
      padding = 'py-2 px-4';
  }

  return (
    <button
      className={`${base} ${color} ${padding} flex items-center justify-center gap-2 whitespace-nowrap ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}; 